import { render } from "./affiliate-link-edit-modal.vue?vue&type=template&id=1491c66d&ts=true"
import script from "./affiliate-link-edit-modal.vue?vue&type=script&lang=ts"
export * from "./affiliate-link-edit-modal.vue?vue&type=script&lang=ts"

import "./affiliate-link-edit-modal.vue?vue&type=style&index=0&id=1491c66d&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__